<template>
  <main dir="rtl" class="flex-1 pb-8">
    <div class="mx-auto px-4 sm:px-6 lg:px-8">
      <div class="flex flex-wrap items-center justify-between gap-3 mb-6">
        <h2 class="text-2xl font-bold text-gray-900">ربط الطالب بالفترة</h2>
        <button
          @click="loadData"
          class="bg-gray-100 hover:bg-gray-200 text-gray-700 px-4 py-2 rounded-lg"
        >
          تحديث
        </button>
      </div>

      <div v-if="loading" class="text-center py-8 text-gray-600">جاري التحميل...</div>
      <div v-if="errorMessage" class="mb-4 bg-red-50 border border-red-200 rounded-lg px-4 py-3 text-red-700">
        {{ errorMessage }}
      </div>

      <div class="bg-white rounded-lg shadow p-4 mb-6">
        <h3 class="text-lg font-semibold text-gray-900 mb-3">إضافة ربط جديد</h3>
        <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-3">
          <select v-model="filterScheduleId" @change="onScheduleChanged" class="w-full p-2 border border-gray-300 rounded-md">
            <option value="">اختر الجدول</option>
            <option v-for="schedule in schedules" :key="schedule.id" :value="schedule.id">
              {{ schedule.title }} ({{ schedule.is_paid ? 'مدفوع' : 'مجاني' }})
            </option>
          </select>

          <select v-model="enrollmentForm.student_id" class="w-full p-2 border border-gray-300 rounded-md">
            <option value="">اختر الطالب</option>
            <option v-for="student in eligibleStudents" :key="student.id" :value="student.id">
              {{ student.full_name || `#${student.id}` }}
            </option>
          </select>

          <select v-model="enrollmentForm.teacher_id" @change="onTeacherChanged" class="w-full p-2 border border-gray-300 rounded-md">
            <option value="">اختر المعلم</option>
            <option v-for="teacher in availableTeachers" :key="teacher.id" :value="teacher.id">
              {{ teacher.name }}
            </option>
          </select>
          <!--
          <div class="w-full">
            <div class="flex gap-2">
              <select v-model="slotTeacherToAdd" class="flex-1 p-2 border border-gray-300 rounded-md">
                <option value="">اختر الفترة</option>
                <option v-for="slot in filteredSlotTeachers" :key="slot.id" :value="slot.id">
                  {{ slotOptionLabel(slot) }}
                </option>
              </select>
              <button
                type="button"
                @click="addSlotTag"
                class="px-3 py-2 bg-indigo-600 hover:bg-indigo-700 text-white rounded-md"
              >
                إضافة
              </button>
            </div>
            <div v-if="selectedSlotTeachers.length" class="flex flex-wrap gap-2 mt-2">
              <span
                v-for="slot in selectedSlotTeachers"
                :key="slot.id"
                class="inline-flex items-center gap-2 bg-indigo-50 text-indigo-700 px-2 py-1 rounded-full text-xs"
              >
                {{ weekdayLabel(slot.weekday) }} - {{ slot.slot_name }} ({{ slot.slot_order }})
                <button type="button" class="text-indigo-700 hover:text-indigo-900" @click="removeSlotTag(slot.id)">×</button>
              </span>
            </div>
            <p v-else class="text-xs text-gray-500 mt-2">اختر فترة واحدة أو أكثر ثم اضغط إضافة</p>
          </div>
          -->
          <div class="w-full">
            <div class="flex gap-2">
              <select v-model="slotGroupOrderToAdd" class="flex-1 p-2 border border-gray-300 rounded-md">
                <option value="">اختر مجموعة فترة</option>
                <option v-for="group in availableSlotGroups" :key="group.order" :value="group.order">
                  {{ group.label }}
                </option>
              </select>
              <button
                type="button"
                @click="addSlotGroupTag"
                class="px-3 py-2 bg-purple-600 hover:bg-purple-700 text-white rounded-md"
              >
                إضافة مجموعة
              </button>
            </div>
            <div v-if="selectedSlotGroups.length" class="flex flex-wrap gap-2 mt-2">
              <span
                v-for="group in selectedSlotGroups"
                :key="group.order"
                class="inline-flex items-center gap-2 bg-purple-50 text-purple-700 px-2 py-1 rounded-full text-xs"
              >
                {{ group.label }}
                <button type="button" class="text-purple-700 hover:text-purple-900" @click="removeSlotGroupTag(group.order)">×</button>
              </span>
            </div>
            <p v-else class="text-xs text-gray-500 mt-2">مثال: فترة الظهر 1 لكل الأيام النشطة</p>
          </div>

          <input
            v-model="enrollmentForm.enrollment_start_date"
            type="date"
            :min="selectedScheduleStartDate || undefined"
            :max="selectedScheduleEndDate || undefined"
            class="w-full p-2 border border-gray-300 rounded-md"
          />

          <input
            v-model="enrollmentForm.enrollment_end_date"
            type="date"
            :min="enrollmentEndMinDate || undefined"
            :max="selectedScheduleEndDate || undefined"
            class="w-full p-2 border border-gray-300 rounded-md"
          />

          <select v-model="enrollmentForm.status" class="w-full p-2 border border-gray-300 rounded-md">
            <option value="active">نشط</option>
            <option value="paused">موقوف</option>
            <option value="cancelled">ملغي</option>
            <option value="completed">مكتمل</option>
          </select>
        </div>
        <textarea
          v-model="enrollmentForm.notes"
          rows="2"
          placeholder="ملاحظات (اختياري)"
          class="w-full mt-3 p-2 border border-gray-300 rounded-md"
        />
        <div class="mt-3">
          <button
            @click="createEnrollment"
            class="bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded-md"
          >
            ربط الطالب بالفترة
          </button>
        </div>
      </div>

      <div class="bg-white rounded-lg shadow p-4 mb-4">
        <h3 class="text-lg font-semibold text-gray-900 mb-3">فلاتر الروابط</h3>
        <div class="grid grid-cols-1 md:grid-cols-4 gap-3">
          <select v-model="filters.student_id" class="w-full p-2 border border-gray-300 rounded-md">
            <option value="">كل الطلاب</option>
            <option v-for="student in eligibleStudents" :key="student.id" :value="student.id">
              {{ student.full_name || `#${student.id}` }}
            </option>
          </select>
          <select v-model="filters.schedule_id" class="w-full p-2 border border-gray-300 rounded-md">
            <option value="">كل الجداول</option>
            <option v-for="schedule in schedules" :key="schedule.id" :value="schedule.id">
              {{ schedule.title }}
            </option>
          </select>
          <select v-model="filters.status" class="w-full p-2 border border-gray-300 rounded-md">
            <option value="">كل الحالات</option>
            <option value="active">نشط</option>
            <option value="paused">موقوف</option>
            <option value="cancelled">ملغي</option>
            <option value="completed">مكتمل</option>
          </select>
          <button
            @click="loadEnrollments(1)"
            class="bg-primary hover:bg-primary/90 text-white rounded-md px-4 py-2"
          >
            تطبيق
          </button>
        </div>
      </div>

      <div class="bg-white rounded-lg shadow overflow-x-auto">
        <div class="px-4 py-3 border-b border-gray-100 flex flex-wrap items-center justify-between gap-3">
          <span class="text-sm text-gray-600">المحدد للحذف: {{ selectedEnrollmentIds.length }}</span>
          <div class="flex items-center gap-2">
            <select v-model.number="enrollmentPagination.per_page" @change="onPageSizeChange" class="p-2 border border-gray-300 rounded-md text-sm">
              <option :value="10">10 لكل صفحة</option>
              <option :value="20">20 لكل صفحة</option>
              <option :value="50">50 لكل صفحة</option>
            </select>
            <button
              class="px-3 py-1 rounded border border-gray-200 bg-white text-sm disabled:opacity-50 disabled:cursor-not-allowed"
              :disabled="loading || enrollmentPagination.current_page <= 1"
              @click="changeEnrollmentPage(enrollmentPagination.current_page - 1)"
            >
              السابق
            </button>
            <span class="text-sm text-gray-600">
              صفحة {{ enrollmentPagination.current_page }} من {{ enrollmentPagination.total_pages || 1 }}
              ({{ enrollmentPagination.total }} عنصر)
            </span>
            <button
              class="px-3 py-1 rounded border border-gray-200 bg-white text-sm disabled:opacity-50 disabled:cursor-not-allowed"
              :disabled="loading || enrollmentPagination.current_page >= (enrollmentPagination.total_pages || 1)"
              @click="changeEnrollmentPage(enrollmentPagination.current_page + 1)"
            >
              التالي
            </button>
          </div>
          <button
            @click="deleteSelectedEnrollments"
            :disabled="!selectedEnrollmentIds.length || loading"
            class="text-red-700 bg-red-50 hover:bg-red-100 disabled:opacity-50 disabled:cursor-not-allowed px-3 py-1 rounded"
          >
            حذف المحدد
          </button>
        </div>
        <table class="min-w-full">
          <thead class="bg-gray-50">
            <tr>
              <th class="px-4 py-3 text-center text-xs font-medium text-gray-500">
                <input
                  type="checkbox"
                  :checked="isAllEnrollmentsSelected"
                  @change="toggleSelectAllEnrollments($event.target.checked)"
                  class="h-4 w-4"
                />
              </th>
              <th class="px-4 py-3 text-center text-xs font-medium text-gray-500">الطالب</th>
              <th class="px-4 py-3 text-center text-xs font-medium text-gray-500">الجدول</th>
              <th class="px-4 py-3 text-center text-xs font-medium text-gray-500">اليوم / الفترة</th>
              <th class="px-4 py-3 text-center text-xs font-medium text-gray-500">المعلم</th>
              <th class="px-4 py-3 text-center text-xs font-medium text-gray-500">المدة</th>
              <th class="px-4 py-3 text-center text-xs font-medium text-gray-500">الحالة</th>
              <th class="px-4 py-3 text-center text-xs font-medium text-gray-500">إجراءات</th>
            </tr>
          </thead>
          <tbody class="divide-y divide-gray-200">
            <tr v-for="row in enrollments" :key="row.id">
              <td class="px-4 py-3 text-sm text-center">
                <input
                  type="checkbox"
                  :checked="selectedEnrollmentIds.includes(row.id)"
                  @change="toggleEnrollmentSelection(row.id, $event.target.checked)"
                  class="h-4 w-4"
                />
              </td>
              <td class="px-4 py-3 text-sm text-center">{{ row.student_name }}</td>
              <td class="px-4 py-3 text-sm text-center">{{ row.schedule_title }}</td>
              <td class="px-4 py-3 text-sm text-center">
                {{ weekdayLabel(row.weekday) }} - {{ row.slot_name }} ({{ row.slot_order }})
              </td>
              <td class="px-4 py-3 text-sm text-center">{{ row.teacher_name }}</td>
              <td class="px-4 py-3 text-sm text-center">
                {{ row.enrollment_start_date }}<span v-if="row.enrollment_end_date"> - {{ row.enrollment_end_date }}</span>
              </td>
              <td class="px-4 py-3 text-sm text-center">
                <select
                  :value="row.status"
                  @change="updateEnrollmentStatus(row, $event.target.value)"
                  class="p-1 border border-gray-300 rounded-md text-sm"
                >
                  <option value="active">نشط</option>
                  <option value="paused">موقوف</option>
                  <option value="cancelled">ملغي</option>
                  <option value="completed">مكتمل</option>
                </select>
              </td>
              <td class="px-4 py-3 text-sm text-center">
                <button
                  @click="deleteEnrollment(row)"
                  class="text-red-700 bg-red-50 hover:bg-red-100 px-3 py-1 rounded"
                >
                  حذف
                </button>
              </td>
            </tr>
            <tr v-if="!enrollments.length">
              <td colspan="8" class="px-4 py-6 text-center text-gray-500">لا توجد روابط حالياً</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </main>
</template>

<script>
import { defineComponent } from 'vue';
import {
  createIqraStudentSlotEnrollment,
  createIqraStudentSlotEnrollmentsBulkBySlotGroup,
  deleteIqraStudentSlotEnrollment,
  listIqraSchedules,
  listIqraSlotTeachers,
  listIqraStudentSlotEnrollments,
  listIqraStudentsWithActiveSubscriptions,
  updateIqraStudentSlotEnrollment,
} from '@/services/iqraSchedules';

export default defineComponent({
  name: 'IqraStudentSlotEnrollmentManagement',
  data() {
    return {
      loading: false,
      errorMessage: '',
      eligibleStudents: [],
      schedules: [],
      slotTeachers: [],
      enrollments: [],
      filters: {
        student_id: '',
        schedule_id: '',
        status: '',
      },
      filterScheduleId: '',
      enrollmentForm: {
        student_id: '',
        teacher_id: '',
        slot_teacher_id: [],
        slot_group_orders: [],
        enrollment_start_date: new Date().toISOString().slice(0, 10),
        enrollment_end_date: '',
        status: 'active',
        notes: '',
      },
      slotTeacherToAdd: '',
      slotGroupOrderToAdd: '',
      selectedEnrollmentIds: [],
      enrollmentPagination: {
        current_page: 1,
        per_page: 20,
        total: 0,
        total_pages: 0,
      },
    };
  },
  computed: {
    selectedSchedule() {
      if (!this.filterScheduleId) return null;
      return this.schedules.find((item) => String(item.id) === String(this.filterScheduleId)) || null;
    },
    selectedScheduleStartDate() {
      return this.normalizeDateValue(this.selectedSchedule?.start_date || this.selectedSchedule?.startDate || '');
    },
    selectedScheduleEndDate() {
      return this.normalizeDateValue(this.selectedSchedule?.end_date || this.selectedSchedule?.endDate || '');
    },
    enrollmentEndMinDate() {
      if (!this.enrollmentForm.enrollment_start_date) return this.selectedScheduleStartDate || '';
      if (!this.selectedScheduleStartDate) return this.enrollmentForm.enrollment_start_date;
      return this.enrollmentForm.enrollment_start_date > this.selectedScheduleStartDate
        ? this.enrollmentForm.enrollment_start_date
        : this.selectedScheduleStartDate;
    },
    availableTeachers() {
      const uniqueTeachers = new Map();

      // Business rule: schedule-level linked teachers should be selectable.
      const scheduleTeachers = this.selectedSchedule?.teachers || [];
      scheduleTeachers.forEach((item) => {
        const teacherId = item?.teacher_id ?? item?.teacher?.id;
        if (!teacherId) return;
        uniqueTeachers.set(String(teacherId), {
          id: Number(teacherId),
          name: item?.teacher?.full_name || item?.teacher?.fullName || `#${teacherId}`,
        });
      });

      // Keep slot-based teachers as a fallback source.
      this.slotTeachers.forEach((slot) => {
        if (!slot.teacher_id) return;
        if (this.filterScheduleId && String(slot.schedule_id) !== String(this.filterScheduleId)) return;
        uniqueTeachers.set(String(slot.teacher_id), {
          id: Number(slot.teacher_id),
          name: slot.teacher_name || `#${slot.teacher_id}`,
        });
      });

      return Array.from(uniqueTeachers.values());
    },
    filteredSlotTeachers() {
      let filtered = this.slotTeachers;
      if (this.filterScheduleId) {
        filtered = filtered.filter((item) => String(item.schedule_id) === String(this.filterScheduleId));
      }
      if (this.enrollmentForm.teacher_id) {
        filtered = filtered.filter((item) => String(item.teacher_id) === String(this.enrollmentForm.teacher_id));
      }
      return filtered;
    },
    selectedSlotTeachers() {
      if (!Array.isArray(this.enrollmentForm.slot_teacher_id)) return [];
      const selectedIds = new Set(this.enrollmentForm.slot_teacher_id.map((item) => String(item)));
      return this.filteredSlotTeachers.filter((item) => selectedIds.has(String(item.id)));
    },
    availableSlotGroups() {
      const groups = new Map();
      this.filteredSlotTeachers.forEach((slot) => {
        const order = Number(slot.slot_order);
        if (!order || groups.has(order)) return;
        groups.set(order, {
          order,
          label: `${slot.slot_name || 'فترة'} (${order}) - كل الأيام النشطة`,
        });
      });
      return Array.from(groups.values()).sort((a, b) => a.order - b.order);
    },
    selectedSlotGroups() {
      if (!Array.isArray(this.enrollmentForm.slot_group_orders)) return [];
      const selected = new Set(this.enrollmentForm.slot_group_orders.map((item) => Number(item)));
      return this.availableSlotGroups.filter((group) => selected.has(Number(group.order)));
    },
    isAllEnrollmentsSelected() {
      if (!this.enrollments.length) return false;
      return this.enrollments.every((row) => this.selectedEnrollmentIds.includes(row.id));
    },
  },
  async mounted() {
    await this.loadData();
  },
  methods: {
    normalizeDateValue(value) {
      const dateText = String(value || '').trim();
      if (!dateText) return '';
      return dateText.slice(0, 10);
    },
    applySelectedScheduleDateRange() {
      if (!this.filterScheduleId) return;
      if (this.selectedScheduleStartDate) {
        this.enrollmentForm.enrollment_start_date = this.selectedScheduleStartDate;
      }
      if (this.selectedScheduleEndDate) {
        this.enrollmentForm.enrollment_end_date = this.selectedScheduleEndDate;
      }
    },
    validateEnrollmentDateRange() {
      if (!this.filterScheduleId) return true;
      const startDate = this.enrollmentForm.enrollment_start_date || '';
      const endDate = this.enrollmentForm.enrollment_end_date || '';
      const scheduleStart = this.selectedScheduleStartDate;
      const scheduleEnd = this.selectedScheduleEndDate;

      if (scheduleStart && startDate && startDate < scheduleStart) {
        alert('تاريخ بداية الربط يجب أن يكون ضمن تاريخ بداية الجدول');
        return false;
      }
      if (scheduleEnd && startDate && startDate > scheduleEnd) {
        alert('تاريخ بداية الربط يجب أن يكون ضمن تاريخ نهاية الجدول');
        return false;
      }
      if (scheduleStart && endDate && endDate < scheduleStart) {
        alert('تاريخ نهاية الربط يجب أن يكون ضمن تاريخ بداية الجدول');
        return false;
      }
      if (scheduleEnd && endDate && endDate > scheduleEnd) {
        alert('تاريخ نهاية الربط يجب أن يكون ضمن تاريخ نهاية الجدول');
        return false;
      }
      return true;
    },
    async loadData() {
      this.loading = true;
      this.errorMessage = '';
      try {
        const [schedulesResult, slotTeachersResult] = await Promise.all([
          listIqraSchedules({ page: 1, size: 200, is_active: true }),
          listIqraSlotTeachers({ is_active: true }),
        ]);

        this.schedules = schedulesResult?.data || [];
        this.slotTeachers = slotTeachersResult || [];
        await this.loadEligibleStudents();
        await this.loadEnrollments();
      } catch (error) {
        this.errorMessage = error?.message || 'فشل في تحميل بيانات الربط';
      } finally {
        this.loading = false;
      }
    },
    async loadEligibleStudents() {
      const params = { page: 1, size: 200 };
      if (this.filterScheduleId) {
        params.schedule_id = Number(this.filterScheduleId);
      }
      const studentsResult = await listIqraStudentsWithActiveSubscriptions(params);
      this.eligibleStudents = studentsResult?.data || [];
    },
    async loadEnrollments(page) {
      this.loading = true;
      this.errorMessage = '';
      try {
        const targetPage = page ?? this.enrollmentPagination.current_page;
        const result = await listIqraStudentSlotEnrollments({
          student_id: this.filters.student_id || undefined,
          schedule_id: this.filters.schedule_id || undefined,
          status: this.filters.status || undefined,
          page: targetPage,
          size: this.enrollmentPagination.per_page,
        });
        this.enrollments = result?.data || [];
        this.enrollmentPagination = {
          current_page: Number(result?.pagination?.current_page ?? targetPage),
          per_page: Number(result?.pagination?.per_page ?? this.enrollmentPagination.per_page),
          total: Number(result?.pagination?.total ?? 0),
          total_pages: Number(result?.pagination?.total_pages ?? 1),
        };
        this.selectedEnrollmentIds = [];
      } catch (error) {
        this.errorMessage = error?.message || 'فشل في تحميل روابط الطلاب';
      } finally {
        this.loading = false;
      }
    },
    changeEnrollmentPage(page) {
      if (page < 1 || page > (this.enrollmentPagination.total_pages || 1) || this.loading) return;
      this.loadEnrollments(page);
    },
    onPageSizeChange() {
      this.enrollmentPagination.current_page = 1;
      this.loadEnrollments(1);
    },
    slotOptionLabel(slot) {
      return `${this.weekdayLabel(slot.weekday)} - ${slot.slot_name}`;
    },
    onScheduleChanged() {
      this.enrollmentForm.student_id = '';
      this.enrollmentForm.teacher_id = '';
      this.enrollmentForm.slot_teacher_id = [];
      this.enrollmentForm.slot_group_orders = [];
      this.slotTeacherToAdd = '';
      this.slotGroupOrderToAdd = '';
      this.applySelectedScheduleDateRange();
      this.loadEligibleStudents();
      this.loadSlotTeachersForSelectedSchedule();
    },
    onTeacherChanged() {
      this.enrollmentForm.slot_teacher_id = [];
      this.enrollmentForm.slot_group_orders = [];
      this.slotTeacherToAdd = '';
      this.slotGroupOrderToAdd = '';
    },
    addSlotTag() {
      if (!this.slotTeacherToAdd) return;
      const slotId = Number(this.slotTeacherToAdd);
      if (!this.enrollmentForm.slot_teacher_id.includes(slotId)) {
        this.enrollmentForm.slot_teacher_id.push(slotId);
      }
      this.slotTeacherToAdd = '';
    },
    removeSlotTag(slotTeacherId) {
      this.enrollmentForm.slot_teacher_id = this.enrollmentForm.slot_teacher_id.filter(
        (item) => Number(item) !== Number(slotTeacherId)
      );
    },
    addSlotGroupTag() {
      if (!this.slotGroupOrderToAdd) return;
      const slotOrder = Number(this.slotGroupOrderToAdd);
      if (!this.enrollmentForm.slot_group_orders.includes(slotOrder)) {
        this.enrollmentForm.slot_group_orders.push(slotOrder);
      }
      this.slotGroupOrderToAdd = '';
    },
    removeSlotGroupTag(slotOrder) {
      this.enrollmentForm.slot_group_orders = this.enrollmentForm.slot_group_orders.filter(
        (item) => Number(item) !== Number(slotOrder)
      );
    },
    async loadSlotTeachersForSelectedSchedule() {
      if (!this.filterScheduleId) {
        this.slotTeachers = [];
        return;
      }
      try {
        this.slotTeachers = await listIqraSlotTeachers({
          schedule_id: Number(this.filterScheduleId),
          is_active: true,
        });
      } catch (error) {
        this.errorMessage = error?.message || 'فشل في تحميل فترات الجدول';
      }
    },
    async createEnrollment() {
      const hasIndividualSlots = Array.isArray(this.enrollmentForm.slot_teacher_id) && this.enrollmentForm.slot_teacher_id.length > 0;
      const hasSlotGroups = Array.isArray(this.enrollmentForm.slot_group_orders) && this.enrollmentForm.slot_group_orders.length > 0;
      if (
        !this.enrollmentForm.student_id ||
        !this.enrollmentForm.enrollment_start_date ||
        (!hasIndividualSlots && !hasSlotGroups)
      ) {
        alert('يرجى اختيار الطالب وفترة واحدة على الأقل أو مجموعة فترات وتاريخ البداية');
        return;
      }

      if (hasSlotGroups && (!this.filterScheduleId || !this.enrollmentForm.teacher_id)) {
        alert('عند اختيار مجموعة فترات يجب تحديد الجدول والمعلم');
        return;
      }
      if (!this.validateEnrollmentDateRange()) {
        return;
      }

      this.loading = true;
      this.errorMessage = '';
      try {
        const payloadBase = {
          student_id: Number(this.enrollmentForm.student_id),
          enrollment_start_date: this.enrollmentForm.enrollment_start_date,
          enrollment_end_date: this.enrollmentForm.enrollment_end_date || null,
          status: this.enrollmentForm.status,
          notes: this.enrollmentForm.notes || null,
        };

        let successCount = 0;
        let skippedCount = 0;
        let failedCount = 0;

        if (hasIndividualSlots) {
          const requests = this.enrollmentForm.slot_teacher_id.map((slotTeacherId) => createIqraStudentSlotEnrollment({
            ...payloadBase,
            slot_teacher_id: Number(slotTeacherId),
          }));
          const result = await Promise.allSettled(requests);
          const individualSuccess = result.filter((item) => item.status === 'fulfilled').length;
          successCount += individualSuccess;
          failedCount += result.length - individualSuccess;
        }

        if (hasSlotGroups) {
          for (const slotOrder of this.enrollmentForm.slot_group_orders) {
            try {
              const groupResult = await createIqraStudentSlotEnrollmentsBulkBySlotGroup({
                ...payloadBase,
                schedule_id: Number(this.filterScheduleId),
                teacher_id: Number(this.enrollmentForm.teacher_id),
                slot_order: Number(slotOrder),
              });
              const summary = groupResult?.summary || {};
              successCount += Number(summary.created_count || 0);
              skippedCount += Number(summary.skipped_count || 0);
              failedCount += Number(summary.failed_count || 0);
            } catch (error) {
              failedCount += 1;
            }
          }
        }

        this.enrollmentForm.slot_teacher_id = [];
        this.enrollmentForm.slot_group_orders = [];
        this.slotTeacherToAdd = '';
        this.slotGroupOrderToAdd = '';
        this.enrollmentForm.enrollment_end_date = '';
        this.enrollmentForm.notes = '';
        await this.loadEnrollments();
        alert(`تم تنفيذ الربط. نجاح: ${successCount}، تجاوز: ${skippedCount}، فشل: ${failedCount}`);
      } catch (error) {
        this.errorMessage = error?.message || 'فشل في إنشاء الربط';
      } finally {
        this.loading = false;
      }
    },
    async updateEnrollmentStatus(row, status) {
      this.loading = true;
      this.errorMessage = '';
      try {
        await updateIqraStudentSlotEnrollment(row.id, { status });
        await this.loadEnrollments();
      } catch (error) {
        this.errorMessage = error?.message || 'فشل في تحديث الحالة';
      } finally {
        this.loading = false;
      }
    },
    async deleteEnrollment(row) {
      const confirmed = window.confirm('هل أنت متأكد من حذف ربط الطالب بهذه الفترة؟');
      if (!confirmed) return;

      this.loading = true;
      this.errorMessage = '';
      try {
        await deleteIqraStudentSlotEnrollment(row.id);
        await this.loadEnrollments();
      } catch (error) {
        this.errorMessage = error?.message || 'فشل في حذف الربط';
      } finally {
        this.loading = false;
      }
    },
    toggleEnrollmentSelection(enrollmentId, isChecked) {
      const id = Number(enrollmentId);
      if (isChecked) {
        if (!this.selectedEnrollmentIds.includes(id)) {
          this.selectedEnrollmentIds.push(id);
        }
        return;
      }
      this.selectedEnrollmentIds = this.selectedEnrollmentIds.filter((item) => Number(item) !== id);
    },
    toggleSelectAllEnrollments(isChecked) {
      if (!isChecked) {
        this.selectedEnrollmentIds = [];
        return;
      }
      this.selectedEnrollmentIds = this.enrollments.map((row) => Number(row.id));
    },
    async deleteSelectedEnrollments() {
      if (!this.selectedEnrollmentIds.length) return;

      const confirmed = window.confirm(`هل أنت متأكد من حذف ${this.selectedEnrollmentIds.length} فترة محددة؟`);
      if (!confirmed) return;

      this.loading = true;
      this.errorMessage = '';
      try {
        const requests = this.selectedEnrollmentIds.map((enrollmentId) => deleteIqraStudentSlotEnrollment(Number(enrollmentId)));
        const result = await Promise.allSettled(requests);
        const successCount = result.filter((item) => item.status === 'fulfilled').length;
        const failedCount = result.length - successCount;
        await this.loadEnrollments();
        alert(`تم حذف المحدد. نجاح: ${successCount}، فشل: ${failedCount}`);
      } catch (error) {
        this.errorMessage = error?.message || 'فشل في حذف الفترات المحددة';
      } finally {
        this.loading = false;
      }
    },
    weekdayLabel(value) {
      const map = {
        1: 'الإثنين',
        2: 'الثلاثاء',
        3: 'الأربعاء',
        4: 'الخميس',
        5: 'الجمعة',
        6: 'السبت',
        7: 'الأحد',
      };
      return map[value] || `اليوم ${value}`;
    },
  },
});
</script>
